import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { CapDonViService } from './cap-don-vi.service';
import { Router } from '@angular/router';
import { ICapDonVi } from './cap-don-vi';
declare var jQuery: any;
@Component({
    selector: 'vnpt-chuc-vu',
    templateUrl: './cap-don-vi.component.html',
    providers: [CapDonViService]
})
export class CapDonViComponent implements OnInit {
    @ViewChild("divTen") divTen : ElementRef;
    @ViewChild("divHang") divHang : ElementRef;
    @ViewChild("inputHang") inputHang : ElementRef;
    @ViewChild("inputTen") inputTen : ElementRef;
    title: string = "Cấp đơn vị"
    listItem: ICapDonVi[] = [];

    detailItem: ICapDonVi;
    saveStatusMessage: string = "";
    saveStatus: boolean = true;

    changeAddUpdate: string = "Thêm mới";

    paging: number = 1;
    totalCount: number = 0;
    totalPages: number = 1;
    total: number;
    page: number;
    keyword: string = '';
    size: number;

    constructor(private service: CapDonViService,
        private router: Router,
        private titleService: Title) {
    }

    ngOnInit() {
        this.titleService.setTitle('Quản lý ' + this.title);
        //this.GetList();
        this.GetListFromPagination(this.paging);
        this.keyword = "";
        this.Reset();
    }

    Reset() {
        this.detailItem = {
            Id: null,
            Hang: null,
            Ten: ''
        }
        this.changeAddUpdate = "Thêm mới";
        this.divTen.nativeElement.hidden = true;
        this.divHang.nativeElement.hidden = true;
    }

    KeyUpTen() {
        this.divTen.nativeElement.hidden = true;
    }

    KeyUpHang() {
        this.divHang.nativeElement.hidden = true;
    }

    // Lấy danh sách từ Stored Procedure phân trang
    GetListFromPagination(paging: number) {
        let pageSize = 8;
        this.service.GetListFromPagination(paging, this.keyword, pageSize)
            .subscribe(
            (data) => {
                this.listItem = data;
                if (this.listItem.length !== 0) {
                    // tổng records trong list cấp đơn vị
                    this.paging = paging;
                    this.totalCount = (data[0]).TotalRows;
                    this.totalPages = Math.ceil(this.totalCount / pageSize); // tính tổng số trang cần phân dựa vào tổng records
                } else {
                    if (paging > 1) {
                        this.GetListFromPagination(paging - 1);
                    } else {
                        this.totalPages = 0;
                    }
                }

            },
            er => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
            });
    }

    createRange(number) {
        let items = [];
        for (var i = 1; i <= number; i++) {
            items.push(i);
        }
        return items;
    }

    valuechange(newValue) {
        this.keyword = newValue;
        this.GetListFromPagination(1);
    }

    // GetList
    GetList() {
        this.service.GetList()
            .subscribe(
            (data) => {
                this.listItem = data;
            },
            er => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
            });

    }

    GetItem(item: ICapDonVi) {
        this.detailItem.Id = item.Id;
        this.detailItem.Hang = item.Hang;
        this.detailItem.Ten = item.Ten;
        this.changeAddUpdate = "Chỉnh sửa";
        this.divTen.nativeElement.hidden = true;
        this.divHang.nativeElement.hidden = true;
    }

    Save(item?: ICapDonVi) {
        if (this.detailItem.Ten && this.detailItem.Hang) {
            this.saveStatusMessage = 'Xin vui lòng đợi trong giây lát!';
            jQuery("#loader").modal();

            this.service.Save(item).subscribe(
                (resp) => {
                    if (resp.Success) {
                        jQuery("#myModalAdd").modal('hide');
                        //this.GetList();
                        this.GetListFromPagination(this.paging);
                        this.saveStatusMessage = this.changeAddUpdate + " " + item.Ten + " thành công!";
                        this.saveStatus = true;
                        jQuery("#loader").modal();
                        this.Reset();
                    }
                    else {
                        this.saveStatusMessage = "Lỗi khi " + this.changeAddUpdate + " " + item.Ten + "! Xin vui lòng thực hiện lại sau";
                        this.saveStatus = false;
                    }
                },
                (er) => {
                    if (er.status == 401) {
                        this.router.navigate(['./login']);
                    }
                    console.log(er);
                    this.saveStatusMessage = "Lỗi khi lưu dữ liệu! Xin vui lòng thực hiện lại sau";
                    this.saveStatus = false;
                }
            )
        } else {
            if (!this.detailItem.Ten) {
                this.divTen.nativeElement.hidden = false;
            }

            if (!this.detailItem.Hang) {
                this.divHang.nativeElement.hidden = false;
            }
        }
    }

    Delete(item: ICapDonVi) {
        this.saveStatusMessage = 'Xin vui lòng đợi trong giây lát !';
        jQuery("#loader").modal({backdrop: 'static', keyboard: true});
        this.service.Delete(item).subscribe(
            (resp) => {
                if (resp.Success) {
                    //this.GetList();
                    this.GetListFromPagination(this.paging);
                    this.saveStatusMessage = "Xóa " + item.Ten + " thành công!";
                    this.saveStatus = true;
                    jQuery("#loader").modal({backdrop: 'static', keyboard: true});
                }
                else {
                    this.saveStatusMessage = "Lỗi khi xóa dữ liệu! Xin vui lòng thực hiện lại sau";
                    this.saveStatus = false;
                }
            },
            (er) => {
                if (er.status == 401) {
                    this.router.navigate(['./login']);
                }
                console.log(er);
                this.saveStatusMessage = "Lỗi khi xóa dữ liệu! Xin vui lòng thực hiện lại sau";
                this.saveStatus = false;
            }
        );
        this.Reset();
    }

}


// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/cap-don-vi/cap-don-vi.component.ts